import React from "react";
import { ReportHeader } from "./ReportHeader";
import "./ReportPreviewDocument.css";

export function ReportPreviewHeader(props) {
  return <ReportHeader variant="preview" {...props} />;
}
